import { SagaIterator } from 'redux-saga';
import { put, select } from 'redux-saga/effects';
import { StorageKey } from '../../../constants/storage';
import { ClientError, DataResponse, FailureOperation, isFailureResponse } from '../../../models/common';
import {
    setDisableRemoteDesktopStatus,
    setDisableRemoteDesktopStatusError,
    setDisableRemoteDesktopStatusFailed,
    setDisableRemoteDesktopStatusSuccess,
} from '../../actions/application/application-action-creators';
import { SetDisableRemoteDesktopStatusAction } from '../../actions/application/application-actions';
import { setStorageValue } from '../../actions/storage/storage-action-creators';
import { createSagaError } from '../../effects/create-saga-error';
import { putAndAwait } from '../../effects/put-and-await';
import { takeEvery } from '../../effects/take';
import { getStorageType } from '../../selector/storage-selectors';
import { getPayload } from '../../utilities/payload-action';

export function* setDisableRemoteDesktopStatusSaga(action: SetDisableRemoteDesktopStatusAction): SagaIterator {
    const remoteDesktopStatus = getPayload(action);

    try {
        const storageType = yield select(getStorageType);
        const setStorageValueResponse: DataResponse = yield putAndAwait(
            setStorageValue({
                key: StorageKey.DisableRemoteDesktopStatus,
                setForSignedInUser: true,
                storageType,
                value: JSON.stringify(remoteDesktopStatus),
            })
        );

        if (isFailureResponse(setStorageValueResponse)) {
            yield put(setDisableRemoteDesktopStatusFailed({ failure: setStorageValueResponse }));
            return;
        }

        yield put(setDisableRemoteDesktopStatusSuccess());
    } catch (err) {
        const error: ClientError = yield createSagaError(err, FailureOperation.SetDisableRemoteDesktopStatus);
        yield put(setDisableRemoteDesktopStatusError({ error }));
    }
}

export function* setDisableRemoteDesktopStatusListenerSaga(): SagaIterator {
    yield takeEvery(setDisableRemoteDesktopStatus, setDisableRemoteDesktopStatusSaga);
}
